





































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import CurrencyInput from '@/components/inputs/CurrencyInput.vue'
import * as organizations from '@/services/organizations'

dayjs.extend(duration)

@Component({
  components: { CurrencyInput },
})
export default class EditDefaultWageDialog extends Vue {
  
  loading = false
  isValid = false
  form = {
    defaultWage: 7.5,
  }

  @Prop({ default: false }) opened!: boolean
  @Prop({ type: Number }) organizationId!: number

  get organization() {
    return this.$store.getters.organization(this.organizationId)
  }

  @Watch('opened')
  onOpened(opened: boolean) {
    this.form.defaultWage = this.organization.minimum_wage
  }

  closeDialog() {
    this.$emit('update:opened', false)
  }

  async updateDefaultWage() {
    try {
      await organizations.updateMyOrganization(this.$store, {
        default_wage: this.form.defaultWage,
      })
      this.closeDialog()
    } finally {
      this.loading = false
    }
  }
}
